import React, { useRef, useState } from "react";
import Loader from "../../../Components/Loader/Loder.jsx";
import { useQuery } from "@tanstack/react-query";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import PptxGenJS from "pptxgenjs";
import stock from "../../../Artifacts/wsrMetrics/Stock.png";
import supply from "../../../Artifacts/wsrMetrics/supply.png";
import outcome from "../../../Artifacts/wsrMetrics/outcome.png";
import demand from "../../../Artifacts/wsrMetrics/demand.png";
import process from "../../../Artifacts/wsrMetrics/Process.png";
import WsrButton from "../../../Components/Buttons/WsrButton.jsx";
import Swal from "sweetalert2";

const WsrMetricsApi = async (body) => {
  try {
    const res = await axInst.post("wsr/second_phase", body);
    const response = res.data;
    return response;
  } catch (error) {
    console.error(error);
    return {};
  }
};
const WsrMetrics = () => {
  const captureRef = useRef(null);
  const [editedData, setEditedData] = useState();
  const [isValidInput, setIsValidInput] = useState({});
  const isAllValid = Object.values(isValidInput).every((valid) => valid);

  const { data: filterdata, submitted } = useSelector(
    (state) => state.filtersOfftake
  );

  // Use react-query for data fetching
  const { data, isFetching, isError } = useQuery({
    queryKey: ["wsr", submitted],
    queryFn: () => WsrMetricsApi(),
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  // Data loading and error handling
  if (isFetching) {
    return (
      <div className=" flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }

  if (isError) {
    return <div>Error fetching data.</div>;
  }
  if (!data || Object.keys(data).length === 0) {
    return (
      <div className="flex items-center justify-center w-full h-full text-xl mt-5">
        No Data Available.
      </div>
    );
  }

  const keys = Object.keys(data);
  const AllRegions = keys.filter((region) => region !== "All Regions");

  const WsrMetricsPutApi = async () => {
    try {
      const res = await axInst.put("wsr/second_phase", editedData);
      const response = res.data;
      // console.log("Response", response);
      await Swal.fire({
        title: "Data Saved",
        icon: "success",
        draggable: true,
        confirmButtonText: "OK",
        didOpen: () => {
          document.querySelector(".swal2-confirm").style.backgroundColor =
            "black";
          document.querySelector(".swal2-confirm").style.color = "white";
        },
      });
      window.location.reload();
      return response;
    } catch (error) {
      console.error(error);
      return {};
    }
  };

  const handleSubmitDetails = () => {
    // console.log("Before handle Submit");
    WsrMetricsPutApi();
    // console.log("After handle Submit");
  };

  //   HandleInputs
  const handleInputChangeForOutcome = (
    e,
    region,
    rowIndex,
    colIndex,
    category
  ) => {
    // console.log(e.target.innerText, region, rowIndex, colIndex, category);

    const key = Object?.keys(data[region]?.Outcome[0][category][colIndex])[0];

    const value = e.target.innerText.replace("%", "").trim();
    const isNumber = !isNaN(value) && value !== "";
    const isValid = isNumber || value === "Edit";

    setIsValidInput((prevValidInputs) => ({
      ...prevValidInputs,
      [`${region}-${category}-${colIndex}`]: isValid,
    }));

    setEditedData((prevData) => ({
      ...prevData,
      [region]: {
        ...(prevData?.[region] || {}),
        [category]: {
          ...(prevData?.[region]?.[category] || {}),
          [key]: value,
        },
      },
    }));
    e.target.style.color = isValid ? "black" : "red";
  };

  // Handle input change for Demand
  const handleInputChangeForDemand = (
    e,
    region,
    rowIndex,
    colIndex,
    category
  ) => {
    // console.log("handleInputChangeForDemand called with:", {
    //   region,
    //   rowIndex,
    //   colIndex,
    //   category,
    // });

    if (!category) {
      console.error(`Category is undefined in handleInputChangeForDemand`);
      return;
    }

    if (
      !data[region]?.demand ||
      !Array.isArray(data[region]?.demand) ||
      !data[region]?.demand[0]
    ) {
      console.error(
        `demand data is missing or incorrect for region: ${region}`
      );
      return;
    }

    const categoryData = data[region]?.demand[0]?.[category];
    if (!categoryData) {
      console.error(
        `Category ${category} is missing in demand for region: ${region}`
      );
      return;
    }

    if (!Array.isArray(categoryData)) {
      console.error(`Category data is not an array for category: ${category}`);
      return;
    }

    if (!categoryData[colIndex]) {
      console.error(
        `Column index ${colIndex} is out of bounds for category: ${category}`
      );
      return;
    }

    const key = Object.keys(categoryData[colIndex])?.[0];

    if (!key) {
      console.error(
        `Key is undefined for category: ${category} at colIndex: ${colIndex}`
      );
      return;
    }
    const value = e.target.innerText.replace("%", "").trim();
    const isNumber = !isNaN(value) && value !== "";
    const isValid = isNumber || value === "Edit";

    setIsValidInput((prevValidInputs) => ({
      ...prevValidInputs,
      [`${region}-${category}-${colIndex}`]: isValid,
    }));

    setEditedData((prevData) => ({
      ...prevData,
      [region]: {
        ...(prevData?.[region] || {}),
        [category]: {
          ...(prevData?.[region]?.[category] || {}),
          [key]: value,
        },
      },
    }));
    e.target.style.color = isValid ? "black" : "red";
  };
  // console.log("Edited Data", editedData);

  // Handle input change for Supply
  const handleInputChangeForSuppply = (
    e,
    region,
    rowIndex,
    colIndex,
    category
  ) => {
    // console.log("handleInputChangeForSuppply called with:", {
    //   region,
    //   rowIndex,
    //   colIndex,
    //   category,
    // });

    if (
      !data[region]?.Supply ||
      !Array.isArray(data[region]?.Supply) ||
      !data[region]?.Supply[0]
    ) {
      console.error(
        `Supply data is missing or incorrect for region: ${region}`
      );
      return;
    }

    const categoryData = data[region]?.Supply[0][category];
    if (!categoryData) {
      console.error(
        `Category ${category} is missing in Supply for region: ${region}`
      );
      return;
    }

    if (!categoryData[colIndex]) {
      console.error(
        `Column index ${colIndex} is out of bounds for category: ${category}`
      );
      return;
    }

    const key = Object.keys(categoryData[colIndex])?.[0];

    if (!key) {
      console.error(
        `Key is undefined for category: ${category} at colIndex: ${colIndex}`
      );
      return;
    }
    const value = e.target.innerText.replace("%", "").trim();
    const isNumber = !isNaN(value) && value !== "";
    const isValid = isNumber || value === "Edit";

    setIsValidInput((prevValidInputs) => ({
      ...prevValidInputs,
      [`${region}-${category}-${colIndex}`]: isValid,
    }));

    setEditedData((prevData) => ({
      ...prevData,
      [region]: {
        ...(prevData?.[region] || {}),
        [category]: {
          ...(prevData?.[region]?.[category] || {}),
          [key]: value,
        },
      },
    }));
    e.target.style.color = isValid ? "black" : "red";
  };

  //Handle input change for Stock position
  const handleInputChangeForStockposition = (
    e,
    region,
    rowIndex,
    colIndex,
    category
  ) => {
    // console.log("handleInputChangeForStockposition called with:", {
    //   region,
    //   rowIndex,
    //   colIndex,
    //   category,
    // });

    if (
      !data[region]?.StockPosition ||
      !Array.isArray(data[region]?.StockPosition) ||
      !data[region]?.StockPosition[0]
    ) {
      console.error(
        `StockPosition data is missing or incorrect for region: ${region}`
      );
      return;
    }

    const categoryData = data[region]?.StockPosition[0]?.[category];

    if (!categoryData) {
      console.error(
        `Category ${category} is missing in StockPosition for region: ${region}`
      );
      return;
    }

    if (!categoryData[colIndex]) {
      console.error(
        `Column index ${colIndex} is out of bounds for category: ${category}`
      );
      return;
    }

    const key = Object.keys(categoryData[colIndex])?.[0];

    if (!key) {
      console.error(
        `Key is undefined for category: ${category} at colIndex: ${colIndex}`
      );
      return;
    }
    const value = e.target.innerText.replace("%", "").trim();
    const isNumber = !isNaN(value) && value !== "";
    const isValid = isNumber || value === "Edit";

    setIsValidInput((prevValidInputs) => ({
      ...prevValidInputs,
      [`${region}-${category}-${colIndex}`]: isValid,
    }));

    setEditedData((prevData) => ({
      ...prevData,
      [region]: {
        ...(prevData?.[region] || {}),
        [category]: {
          ...(prevData?.[region]?.[category] || {}),
          [key]: value,
        },
      },
    }));
    e.target.style.color = isValid ? "black" : "red";
  };

  // Handle input change for process
  const handleInputChangeForStockProcess = (
    e,
    region,
    rowIndex,
    colIndex,
    category
  ) => {
    // console.log("handleInputChangeForStockProcess called with:", {
    //   region,
    //   rowIndex,
    //   colIndex,
    //   category,
    // });

    if (
      !data[region]?.Process ||
      !Array.isArray(data[region]?.Process) ||
      !data[region]?.Process[0]
    ) {
      console.error(
        `Process data is missing or incorrect for region: ${region}`
      );
      return;
    }

    const categoryData = data[region]?.Process[0]?.[category];

    if (!categoryData) {
      console.error(
        `Category ${category} is missing in Outcome for region: ${region}`
      );
      return;
    }

    if (!categoryData[colIndex]) {
      console.error(
        `Column index ${colIndex} is out of bounds for category: ${category}`
      );
      return;
    }

    const key = Object.keys(categoryData[colIndex])?.[0];

    if (!key) {
      console.error(
        `Key is undefined for category: ${category} at colIndex: ${colIndex}`
      );
      return;
    }
    const value = e.target.innerText.replace("%", "").trim();
    const isNumber = !isNaN(value) && value !== "";
    const isValid = isNumber || value === "Edit";

    setIsValidInput((prevValidInputs) => ({
      ...prevValidInputs,
      [`${region}-${category}-${colIndex}`]: isValid,
    }));

    setEditedData((prevData) => ({
      ...prevData,
      [region]: {
        ...(prevData?.[region] || {}),
        [category]: {
          ...(prevData?.[region]?.[category] || {}),
          [key]: value,
        },
      },
    }));
    e.target.style.color = isValid ? "black" : "red";
  };

  // console.log("Edited Data", editedData);

  const handleCaptureAndAddToPpt = () => {
    const element = captureRef.current; // Your table container reference
    const pptx = new PptxGenJS();
    const slide = pptx.addSlide();

    const table = element.querySelector("table");
    const tableWidth = 10; // Total width of the table in inches
    const rows = Array.from(table.querySelectorAll("tr"));
    const rowData = [];
    const rowspanMap = {}; // Track rowspan to avoid duplicate rendering

    // Add Header
    slide.addShape(pptx.ShapeType.rect, {
      x: 0,
      y: 0,
      w: 10,
      h: 0.3,
      fill: { color: "#2a5775" },
    });
    slide.addText("Weekly Sales Metrics", {
      x: 0,
      y: 0,
      w: 10,
      h: 0.3,
      fontSize: 12,
      bold: true,
      color: "#FFFFFF",
      align: "center",
      valign: "middle",
    });

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.querySelectorAll("th, td"));
      const cellData = [];
      let colIndex = 0;

      cells.forEach((cell) => {
        // const fontSize =
        //   parseInt(window.getComputedStyle(cell).fontSize, 10) || 9; // Default font size

        const fontSize =
          cell.tagName === "TH"
            ? 10
            : parseInt(window.getComputedStyle(cell).fontSize, 10) || 9;

        // Skip over columns already handled by rowspan
        while (rowspanMap[`${rowIndex}-${colIndex}`]) {
          colIndex++;
        }

        const text = cell.textContent.trim();
        const colSpan = parseInt(cell.getAttribute("colspan"), 10) || 1;
        const rowSpan = parseInt(cell.getAttribute("rowspan"), 10) || 1;

        let backgroundColor =
          cell.tagName === "TH"
            ? "#2a5775"
            : rowIndex % 2 === 0
            ? "#e5e7eb"
            : "#ffffff";

        const textColor = cell.tagName === "TH" ? "#FFFFFF" : "#000000";

        cellData.push({
          text,
          options: {
            bold: cell.tagName === "TH",
            fill: { color: backgroundColor },
            fontSize: fontSize * 0.5,
            color: textColor,
            align: "center",
            valign: "middle",
            colspan: colSpan,
            rowspan: rowSpan,
          },
        });

        for (let r = 0; r < rowSpan; r++) {
          for (let c = 0; c < colSpan; c++) {
            rowspanMap[`${rowIndex + r}-${colIndex + c}`] = true;
          }
        }
        colIndex += colSpan;
      });

      rowData.push(cellData);
    });

    // Dynamically calculate column widths
    const totalColumns = rowData[0]?.reduce(
      (sum, cell) => sum + (cell.options.colspan || 1),
      0
    );

    const firstColWidth = 0.6; // Width for the first column
    const secondColWidth = 1.2; // Increased width for the second column
    const remainingWidth = tableWidth - firstColWidth - secondColWidth;

    const colW = Array(totalColumns).fill(remainingWidth / (totalColumns - 2));
    colW[0] = firstColWidth;
    if (totalColumns > 1) colW[1] = secondColWidth;

    slide.addTable(rowData, {
      x: 0,
      y: 0.33,
      w: tableWidth,
      border: { pt: 0.5, color: "000000" },
      colW: colW,
    });

    pptx.writeFile({
      fileName: "Weekly Sales Metrics.pptx",
    });
  };

  return (
    <>
      <div
        ref={captureRef}
        style={{ backgroundColor: "#f2f5f9", padding: "2px" }}
      >
        <div className="w-full flex justify-end p-2">
          <div className="flex gap-2 items-center mr-4">
            <div className="h-4 w-4 border border-black bg-gray-300 rounded-sm"></div>
            <p className="text-sm">Editable Fields</p>
          </div>
        </div>
        <div className="drilltable pb-2 ">
          <table className="w-full border-collapse border-2 border-[#2A5775] text-left text-sm">
            <thead className="sticky text-white top-0 bg-[#2A5775] text-left z-[1]">
              <tr className="text-center">
                <th
                  rowSpan="2"
                  className="border border-gray-400 p-1 text-sm w-[80px]"
                >
                  Bucket
                </th>
                <th
                  rowSpan="2"
                  className="border border-gray-400 p-1 text-sm w-[150px]"
                >
                  Metric
                </th>
                <th colSpan="4" className="border border-gray-400 p-1 text-sm">
                  India
                </th>
                {AllRegions.map((region) => {
                  return (
                    <>
                      <th
                        colSpan="4"
                        className="border border-gray-400 p-1 text-sm"
                      >
                        {region}
                      </th>
                    </>
                  );
                })}
              </tr>
              <tr className="text-center">
                {[...Array(AllRegions.length + 1)]?.map((_, rowIndex) => (
                  <>
                    {[
                      "Month Target",
                      "MTD Target",
                      "Actual Retail",
                      "LM MTD Actual",
                    ]?.map((col, index) => (
                      <th
                        key={`${rowIndex}-${index}`}
                        className="border border-gray-400 p-1"
                      >
                        {col}
                      </th>
                    ))}
                  </>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* outcome */}
              {[
                "Realization (%)",
                "Vahan share",
                "Retail (Vol)",
                "Offtake(Vol)",
                "VAS (No.)",
              ]?.map((category, categoryIndex) => (
                <tr
                  className={`bg-gray-300  text-center ${
                    categoryIndex === 4 ? "border-b-2 border-[#2A5775]" : ""
                  }`}
                  key={categoryIndex}
                >
                  {categoryIndex === 0 && (
                    <td className="bg-[#D4E1EC] font-bold" rowSpan="5">
                      <img
                        src={outcome}
                        alt="outcome"
                        className="w-[72px] h-[72px]"
                      />
                      Outcome
                    </td>
                  )}
                  <td className="border border-gray-400 text-left p-1 bg-[#D4E1EC] font-semibold">
                    {category}
                  </td>
                  {() => {
                    const sumForMonthTarget = AllRegions?.map(
                      (region) => data?.[region]
                    );
                    // console.log(sumForMonthTarget);
                  }}
                  {(() => {
                    // Initialize sums for numerical values
                    const sums = {
                      Month_Target: 0,
                      MTD_Target: 0,
                      Actual: 0,
                      LMMTD: 0,
                    };

                    // Iterate over all regions to sum Month_Target and other fields
                    AllRegions?.forEach((region) => {
                      const regionData =
                        data?.[region]?.Outcome?.[0]?.[category] || [];

                      regionData.forEach((item) => {
                        Object.keys(sums).forEach((key) => {
                          let value = item[key];

                          // Handle "Edit" placeholders safely
                          if (
                            typeof value === "string" &&
                            value.trim().toLowerCase() === "edit"
                          ) {
                            value = 0;
                          }

                          if (
                            !isNaN(value) &&
                            value !== undefined &&
                            value !== null
                          ) {
                            sums[key] += Number(value);
                          }
                        });
                      });
                    });

                    // Handle Realization (%) separately
                    if (category === "Realization (%)") {
                      const regionSums = [
                        "North",
                        "East",
                        "West",
                        "South",
                      ].reduce(
                        (totals, region) => {
                          const regionData = data?.[region];

                          totals.DISCOUNT_PERCENTAGE_NUM += Number(
                            regionData?.DISCOUNT_PERCENTAGE_NUM || 0
                          );
                          totals.DISCOUNT_PERCENTAGE_DEN += Number(
                            regionData?.DISCOUNT_PERCENTAGE_DEN || 0
                          );
                          totals.DISCOUNT_PERCENTAGE_NUM_LMTD += Number(
                            regionData?.DISCOUNT_PERCENTAGE_NUM_LMTD || 0
                          );
                          totals.DISCOUNT_PERCENTAGE_DEN_LMTD += Number(
                            regionData?.DISCOUNT_PERCENTAGE_DEN_LMTD || 0
                          );

                          return totals;
                        },
                        {
                          DISCOUNT_PERCENTAGE_NUM: 0,
                          DISCOUNT_PERCENTAGE_DEN: 0,
                          DISCOUNT_PERCENTAGE_NUM_LMTD: 0,
                          DISCOUNT_PERCENTAGE_DEN_LMTD: 0,
                        }
                      );

                      // Calculate Realization (%) values
                      const actual =
                        regionSums.DISCOUNT_PERCENTAGE_NUM > 0
                          ? (
                              (regionSums.DISCOUNT_PERCENTAGE_NUM /
                                regionSums.DISCOUNT_PERCENTAGE_DEN) *
                              100
                            ).toFixed(1) + "%"
                          : "0%";

                      const lmmtd =
                        regionSums.DISCOUNT_PERCENTAGE_NUM_LMTD > 0
                          ? (
                              (regionSums.DISCOUNT_PERCENTAGE_NUM_LMTD /
                                regionSums.DISCOUNT_PERCENTAGE_DEN_LMTD) *
                              100
                            ).toFixed(1) + "%"
                          : "0%";

                      return [
                        sums.Month_Target,
                        sums.MTD_Target,
                        actual,
                        lmmtd,
                      ].map((value, idx) => (
                        <td
                          key={idx}
                          className={`border border-gray-400 bg-white text-xs shadow-custom ${
                            idx === 3 ? "border-r-[#2A5775] border-r-2" : ""
                          }`}
                          contentEditable={value === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {value}
                        </td>
                      ));
                    }

                    // Debugging output
                    // console.log("Summed values:", sums);

                    // Return numerical sums for other categories
                    return Object.values(sums).map((value, idx) => (
                      <td
                        key={idx}
                        className={`border-l border-t border-b bg-white border-gray-400 text-xs shadow-custom ${
                          (idx + 1) % 4 === 0
                            ? "border-r-2 border-r-[#2A5775]"
                            : ""
                        }`}
                        contentEditable={value === 0 || value === "Edit"}
                        suppressContentEditableWarning={true}
                      >
                        {value}
                      </td>
                    ));
                  })()}

                  {/* Display data for all regions */}
                  {AllRegions?.map((region, rowIndex) =>
                    data[region].Outcome[0][category].map((item, colIndex) => (
                      // console.log("Item", item),

                      <td
                        className={`border border-gray-300 text-xs shadow-custom ${
                          (colIndex + 1) % 4 === 0
                            ? "border-r-2 border-r-[#2A5775]"
                            : ""
                        }
                      ${
                        ["Retail (Vol)", "Offtake(Vol)"].includes(category) &&
                        [0, 1, 2, 3].includes(colIndex)
                          ? "pointer-events-none bg-white border"
                          : ""
                      }
                      ${
                        category === "Realization (%)" &&
                        [0, 1, 2, 3].includes(rowIndex) &&
                        [2, 3].includes(colIndex)
                          ? "pointer-events-none bg-white"
                          : ""
                      }
                      `}
                        key={`${region}-${rowIndex}`}
                        contentEditable={
                          Object.values(item)[0] === "Edit" ||
                          Object.values(item)[0] === 0 ||
                          colIndex === 0 ||
                          colIndex === 1 ||
                          colIndex === 2 ||
                          colIndex === 3
                        }
                        suppressContentEditableWarning={true}
                        onBlur={(e) =>
                          handleInputChangeForOutcome(
                            e,
                            region,
                            rowIndex,
                            colIndex,
                            category
                          )
                        }
                        // onClick={() =>
                        //   console.log(
                        //     `Row: ${rowIndex}, Column: ${colIndex}, category: ${category}`
                        //   )
                        // }
                      >
                        {Object.values(item)[0]}
                      </td>
                    ))
                  )}
                </tr>
              ))}
              {/* demand */}
              {[
                "TQP",
                "Conv (c1 -> c3)",
                "# of Login Cases",
                "# of Leads generated through activities",
                "# of activities executed",
                "Live Deal Visibility",
              ]?.map((category, categoryIndex) => (
                <tr
                  className={`bg-gray-300  text-center ${
                    categoryIndex === 5 ? "border-b-2 border-[#2A5775]" : ""
                  }`}
                  key={categoryIndex}
                >
                  {categoryIndex === 0 && (
                    <td
                      className="bg-[#CFD8DC] shadow-custom font-bold"
                      rowSpan="6"
                    >
                      <img
                        src={demand}
                        alt="demand"
                        className="w-[80px] h-[72px] "
                      />
                      Demand
                    </td>
                  )}

                  <td className="border border-gray-400 text-left p-1 bg-[#CFD8DC] shadow-custom font-semibold">
                    {category}
                  </td>

                  {(() => {
                    const sums = {
                      Month_Target: 0,
                      MTD_Target: 0,
                      Actual: 0,
                      LMMTD: 0,
                    };

                    AllRegions?.forEach((region) => {
                      const regionData =
                        data?.[region]?.demand?.[0]?.[category] || [];

                      regionData.forEach((item) => {
                        Object.keys(sums).forEach((key) => {
                          let value = item[key];

                          // Handle "Edit" placeholders safely
                          if (
                            typeof value === "string" &&
                            value.trim().toLowerCase() === "edit"
                          ) {
                            value = 0;
                          }

                          if (
                            !isNaN(value) &&
                            value !== undefined &&
                            value !== null
                          ) {
                            sums[key] += Number(value);
                          }
                        });
                      });
                    });

                    const regionSums = [
                      "North",
                      "East",
                      "West",
                      "South",
                    ].reduce(
                      (totals, region) => {
                        const regionData = data?.[region];

                        if (category === "Conv (c1 -> c3)") {
                          totals.C1_QTY += Number(regionData?.C1_QTY || 0);
                          totals.C3_QTY += Number(regionData?.C3_QTY || 0);
                          totals.C1_QTY_LMTD += Number(
                            regionData?.C1_QTY_LMTD || 0
                          );
                          totals.C3_QTY_LMTD += Number(
                            regionData?.C3_QTY_LMTD || 0
                          );
                        } else if (category === "Live Deal Visibility") {
                          totals.ldv_num += Number(regionData?.ldv_num || 0);
                          totals.ldv_den += Number(regionData?.ldv_den || 0);
                          totals.ldv_num_lmtd += Number(
                            regionData?.ldv_num_lmtd || 0
                          );
                          totals.ldv_den_lmtd += Number(
                            regionData?.ldv_den_lmtd || 0
                          );
                        }

                        return totals;
                      },
                      {
                        C1_QTY: 0,
                        C3_QTY: 0,
                        ldv_num: 0,
                        ldv_den: 0,
                        ldv_num_lmtd: 0,
                        ldv_den_lmtd: 0,
                        C1_QTY_LMTD: 0,
                        C3_QTY_LMTD: 0,
                      }
                    );

                    if (category === "Conv (c1 -> c3)") {
                      const actual =
                        regionSums.C1_QTY > 0
                          ? (
                              (regionSums.C3_QTY / regionSums.C1_QTY) *
                              100
                            ).toFixed(1) + "%"
                          : "0%";

                      const lmmtd =
                        regionSums.C1_QTY_LMTD > 0
                          ? (
                              (regionSums.C3_QTY_LMTD /
                                regionSums.C1_QTY_LMTD) *
                              100
                            ).toFixed(1) + "%"
                          : "0%";

                      return [
                        sums.Month_Target,
                        sums.MTD_Target,
                        actual,
                        lmmtd,
                      ].map((value, idx) => (
                        <td
                          key={idx}
                          className={`bg-white border border-gray-400 text-xs shadow-custom ${
                            idx === 3 ? "border-r-[#2A5775] border-r-2" : ""
                          }
                        `}
                          contentEditable={value === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {value}
                        </td>
                      ));
                    }

                    if (category === "Live Deal Visibility") {
                      const actual =
                        regionSums.ldv_den > 0
                          ? (
                              (regionSums.ldv_num / regionSums.ldv_den) *
                              100
                            ).toFixed(1) + "%"
                          : "0%";

                      const lmActual =
                        regionSums.ldv_den_lmtd > 0
                          ? (
                              (regionSums.ldv_num_lmtd /
                                regionSums.ldv_den_lmtd) *
                              100
                            ).toFixed(1) + "%"
                          : "0%";

                      return [
                        sums.Month_Target,
                        sums.MTD_Target,
                        actual,
                        lmActual,
                      ].map((value, idx) => (
                        <td
                          key={idx}
                          className={`bg-white border border-gray-400 text-xs shadow-custom ${
                            idx === 3 ? "border-r-[#2A5775] border-r-2" : ""
                          }`}
                          contentEditable={value === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {value}
                        </td>
                      ));
                    }
                    // console.log("Summed values:", sums);
                    return Object.values(sums).map((value, idx) => (
                      <td
                        key={idx}
                        className={`bg-white border border-gray-400 text-xs shadow-custom ${
                          (idx + 1) % 4 === 0
                            ? "border-r-2 border-r-[#2A5775]"
                            : ""
                        }`}
                        contentEditable={value === 0 || value === "Edit"}
                        suppressContentEditableWarning={true}
                      >
                        {value}
                      </td>
                    ));
                  })()}

                  {AllRegions?.map((region, rowIndex) =>
                    data[region].demand[0][category].map((item, colIndex) => (
                      // console.log("Item", item),

                      <td
                        className={`border border-gray-400 text-xs shadow-custom ${
                          (colIndex + 1) % 4 === 0
                            ? "border-r-2 border-r-[#2A5775]"
                            : ""
                        }
                       ${
                         [
                           "TQP",
                           "# of Leads generated through activities",
                           "# of activities executed",
                         ].includes(category) && [0, 1, 2, 3].includes(colIndex)
                           ? "pointer-events-none bg-white"
                           : ""
                       }
                        ${
                          category === "Conv (c1 -> c3)" &&
                          [0, 1, 2, 3].includes(rowIndex) &&
                          [2, 3].includes(colIndex)
                            ? "pointer-events-none bg-white"
                            : ""
                        }
                        ${
                          category === "Live Deal Visibility" &&
                          [0, 1, 2, 3].includes(rowIndex) &&
                          [2, 3].includes(colIndex)
                            ? "pointer-events-none bg-white"
                            : ""
                        }
                      //
                      //    ["Conv (c1 -> c3)", "Live Deal Visibility"].includes(
                      //      category
                      //    ) &&
                      //    [0, 1, 2, 3].includes(rowIndex) &&
                      //    [2, 3].includes(colIndex)
                      //      ? "pointer-events-none bg-gray-300"
                      //      : ""
                      //  }
                      `}
                        key={`${region}-${rowIndex}`}
                        contentEditable={
                          Object.values(item)[0] === "Edit" ||
                          Object.values(item)[0] === 0 ||
                          colIndex === 0 ||
                          colIndex === 1 ||
                          colIndex === 2 ||
                          colIndex === 3
                        }
                        suppressContentEditableWarning={true}
                        onBlur={(e) =>
                          handleInputChangeForDemand(
                            e,
                            region,
                            rowIndex,
                            colIndex,
                            category
                          )
                        }
                        // onClick={() =>
                        //   console.log(
                        //     `Row: ${rowIndex}, Column: ${colIndex}, category: ${category}`
                        //   )
                        // }
                      >
                        {Object.values(item)[0]}
                      </td>
                    ))
                  )}
                </tr>
              ))}
              {/* Supply */}
              {[
                "Vol Produced  and available  in SFLT (MAPE* base including FBV)",
                "OTIF (%)",
                "Supply against critical requirement inc FBV (target vs actual dispatch)",
              ]?.map((category, categoryIndex) => (
                <tr
                  className={`bg-gray-300  text-center ${
                    categoryIndex === 2 ? "border-b-2 border-[#2A5775]" : ""
                  }`}
                  key={categoryIndex}
                >
                  {categoryIndex === 0 && (
                    <td
                      className="bg-[#D4E1EC] shadow-custom font-bold"
                      rowSpan="3"
                    >
                      <img
                        src={supply}
                        alt="supply"
                        className="w-[80px] h-[72px] "
                      />
                      Supply
                    </td>
                  )}

                  <td className="border border-gray-400 text-left p-1 bg-[#D4E1EC] shadow-custom font-semibold">
                    {category}
                  </td>
                  {(() => {
                    const sums = {
                      Month_Target: 0,
                      MTD_Target: 0,
                      Actual: 0,
                      LMMTD: 0,
                    };

                    AllRegions?.forEach((region) => {
                      data[region]?.Supply[0][category]?.forEach((item) => {
                        Object.keys(sums)?.forEach((key) => {
                          let value = item[key];

                          if (value === "Edit") {
                            value = 0; // Replace "Edit" with 0
                          }

                          if (!isNaN(value)) {
                            sums[key] += Number(value); // Convert to number and sum it
                          }
                        });
                      });
                    });

                    return (
                      <>
                        <td
                          className="bg-white border border-gray-400 text-xs shadow-custom"
                          contentEditable={sums.Month_Target === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {sums.Month_Target}
                        </td>
                        <td
                          className="bg-white border border-gray-400 text-xs shadow-custom"
                          contentEditable={sums.MTD_Target === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {sums.MTD_Target}
                        </td>
                        <td
                          className="bg-white border border-gray-400 text-xs shadow-custom"
                          contentEditable={sums.Actual === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {sums.Actual}
                        </td>
                        <td
                          className="bg-white border border-gray-400 border-r-gray-600 border-r-2 text-xs shadow-custom"
                          contentEditable={sums.LMMTD === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {sums.LMMTD}
                        </td>
                      </>
                    );
                  })()}

                  {AllRegions?.map((region, rowIndex) =>
                    data[region].Supply[0][category].map((item, colIndex) => (
                      // console.log("Item", item),

                      <td
                        className={`border border-gray-400 text-xs shadow-custom ${
                          (colIndex + 1) % 4 === 0
                            ? "border-r-2 border-r-[#2A5775]"
                            : ""
                        }`}
                        key={`${region}-${rowIndex}`}
                        contentEditable={
                          Object.values(item)[0] === "Edit" ||
                          Object.values(item)[0] === 0 ||
                          colIndex === 0 ||
                          colIndex === 1 ||
                          colIndex === 2 ||
                          colIndex === 3
                        }
                        suppressContentEditableWarning={true}
                        onBlur={(e) =>
                          handleInputChangeForSuppply(
                            e,
                            region,
                            rowIndex,
                            colIndex,
                            category
                          )
                        }
                        // onClick={() =>
                        //   console.log(
                        //     `Row: ${rowIndex}, Column: ${colIndex}, category: ${category}`
                        //   )
                        // }
                      >
                        {Object.values(item)[0]}
                      </td>
                    ))
                  )}
                </tr>
              ))}
              {/* Dealer Position */}
              {["Dealer Stock", "TML Stock", "TML Ageing Stock (>1 year)"]?.map(
                (category, categoryIndex) => (
                  <tr
                    className={`bg-gray-300 text-center ${
                      categoryIndex === 2 ? "border-b-2 border-[#2A5775]" : ""
                    }`}
                    key={categoryIndex}
                  >
                    {categoryIndex === 0 && (
                      <td
                        className="bg-[#CFD8DC] shadow-custom font-bold"
                        rowSpan="3"
                      >
                        <img
                          src={stock}
                          alt="outcome"
                          className="w-[px] h-[72px] "
                        />
                        Stock Position
                      </td>
                    )}

                    <td className="border border-gray-400 text-left p-1 bg-[#CFD8DC] shadow-custom font-semibold">
                      {category}
                    </td>

                    {(() => {
                      const sums = {
                        Month_Target: 0,
                        MTD_Target: 0,
                        Actual: 0,
                        LMMTD: 0,
                      };

                      AllRegions?.forEach((region) => {
                        data[region]?.StockPosition[0][category]?.forEach(
                          (item) => {
                            Object.keys(sums)?.forEach((key) => {
                              let value = item[key];

                              if (value === "Edit") {
                                value = 0; // Replace "Edit" with 0
                              }

                              if (!isNaN(value)) {
                                sums[key] += Number(value); // Convert to number and sum it
                              }
                            });
                          }
                        );
                      });

                      return (
                        <>
                          <td
                            className="bg-white border border-gray-400 text-xs shadow-custom"
                            contentEditable={sums.Month_Target === "Edit"}
                            suppressContentEditableWarning={true}
                          >
                            {sums.Month_Target}
                          </td>
                          <td
                            className="bg-white border border-gray-400 text-xs shadow-custom"
                            contentEditable={sums.MTD_Target === "Edit"}
                            suppressContentEditableWarning={true}
                          >
                            {sums.MTD_Target}
                          </td>
                          <td
                            className="bg-white border border-gray-400 text-xs shadow-custom"
                            contentEditable={sums.Actual === "Edit"}
                            suppressContentEditableWarning={true}
                          >
                            {sums.Actual}
                          </td>
                          <td
                            className="bg-white border border-gray-400 border-r-[#2A5775] border-r-2 text-xs shadow-custom"
                            contentEditable={sums.LMMTD === "Edit"}
                            suppressContentEditableWarning={true}
                          >
                            {sums.LMMTD}
                          </td>
                        </>
                      );
                    })()}

                    {AllRegions?.map((region, rowIndex) =>
                      data[region].StockPosition[0][category].map(
                        (item, colIndex) => (
                          // console.log("Item", item),

                          <td
                            className={`border border-gray-400 text-xs shadow-custom ${
                              (colIndex + 1) % 4 === 0
                                ? "border-r-2 border-r-[#2A5775]"
                                : ""
                            }`}
                            key={`${region}-${rowIndex}`}
                            contentEditable={
                              Object.values(item)[0] === "Edit" ||
                              Object.values(item)[0] === 0 ||
                              colIndex === 0 ||
                              colIndex === 1 ||
                              colIndex === 2 ||
                              colIndex === 3
                            }
                            suppressContentEditableWarning={true}
                            onBlur={(e) =>
                              handleInputChangeForStockposition(
                                e,
                                region,
                                rowIndex,
                                colIndex,
                                category
                              )
                            }
                            // onClick={() =>
                            //   console.log(
                            //     `Row: ${rowIndex}, Column: ${colIndex}, category: ${category}`
                            //   )
                            // }
                          >
                            {Object.values(item)[0]}
                          </td>
                        )
                      )
                    )}
                  </tr>
                )
              )}
              {/* Process */}
              {["N=1 adoption %"]?.map((category, categoryIndex) => (
                <tr
                  className="bg-gray-300 border border-gray-400 text-center"
                  key={categoryIndex}
                >
                  {categoryIndex === 0 && (
                    <td
                      className="bg-[#D4E1EC] shadow-custom font-bold"
                      rowSpan="3"
                    >
                      <img
                        src={process}
                        alt="outcome"
                        className="w-[80px] h-[72px] "
                      />
                      Process
                    </td>
                  )}

                  <td className="border border-gray-400 text-left p-1 bg-[#d4e1ec] shadow-custom font-semibold">
                    {category}
                  </td>

                  {(() => {
                    const sums = {
                      Month_Target: 0,
                      MTD_Target: 0,
                      Actual: 0,
                      LMMTD: 0,
                    };
                    AllRegions?.forEach((region) => {
                      data[region]?.Process[0][category]?.forEach((item) => {
                        Object.keys(sums)?.forEach((key) => {
                          let value = item[key];

                          if (value === "Edit") {
                            value = 0; // Replace "Edit" with 0
                          }

                          if (!isNaN(value)) {
                            sums[key] += Number(value); // Convert to number and sum it
                          }
                        });
                      });
                    });

                    return (
                      <>
                        <td
                          className="bg-white border border-gray-400 text-xs shadow-custom"
                          contentEditable={sums.Month_Target === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {sums.Month_Target}
                        </td>
                        <td
                          className="bg-white border border-gray-400 text-xs shadow-custom"
                          contentEditable={sums.MTD_Target === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {sums.MTD_Target}
                        </td>
                        <td
                          className="bg-white border border-gray-400 text-xs shadow-custom"
                          contentEditable={sums.Actual === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {sums.Actual}
                        </td>
                        <td
                          className="bg-white border border-gray-400 border-r-[#2A5775] border-r-2 text-xs shadow-custom"
                          contentEditable={sums.LMMTD === "Edit"}
                          suppressContentEditableWarning={true}
                        >
                          {sums.LMMTD}
                        </td>
                      </>
                    );
                  })()}

                  {AllRegions?.map((region, rowIndex) =>
                    data[region].Process[0][category].map((item, colIndex) => (
                      // console.log("Item", item),

                      <td
                        className={`border border-gray-400 text-xs shadow-custom ${
                          (colIndex + 1) % 4 === 0
                            ? "border-r-2 border-r-[#2A5775]"
                            : ""
                        }`}
                        key={`${region}-${rowIndex}`}
                        contentEditable={
                          Object.values(item)[0] === "Edit" ||
                          Object.values(item)[0] === 0 ||
                          colIndex === 0 ||
                          colIndex === 1 ||
                          colIndex === 2 ||
                          colIndex === 3
                        }
                        suppressContentEditableWarning={true}
                        onBlur={(e) =>
                          handleInputChangeForStockProcess(
                            e,
                            region,
                            rowIndex,
                            colIndex,
                            category
                          )
                        }
                        // onClick={() =>
                        //   console.log(
                        //     `Row: ${rowIndex}, Column: ${colIndex}, category: ${category}`
                        //   )
                        // }
                      >
                        {Object.values(item)[0]}
                      </td>
                    ))
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center gap-4">
          <div className="flex justify-end items-end">
            <button
              className={`bg-[#2A5775] h-10 text-nowrap text-sm text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300`}
              title="Submit Details"
              onClick={handleSubmitDetails}
              disabled={!isAllValid}
            >
              Save Details
            </button>
          </div>
          <div>
            <WsrButton handleCaptureAndAddToPpt={handleCaptureAndAddToPpt} />
          </div>
        </div>
      </div>
    </>
  );
};

export default WsrMetrics;
